import React from "react";
import { Skeleton } from "@mui/material";
import { MuiBox, MuiTypography } from "components/atoms";
import { useTranslation } from "react-i18next";

const ShareFolderModalSkeleton = () => {
  const { t } = useTranslation();

  return (
    <MuiBox
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "16px",
      }}
    >
      {/* Add people input */}
      <MuiBox sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <Skeleton
          variant="rounded"
          height={44}
          width="100%"
          sx={{ borderRadius: "8px" }}
        />
      </MuiBox>

      {/* General access */}
      <MuiBox sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
        <MuiTypography fontWeight="600" variant="14" color="text.darkBlack">
          {t("modal.shareFileFolder.generalAccess")}
        </MuiTypography>

        <MuiBox sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Skeleton
            variant="circular"
            width={40}
            height={40}
            sx={{ flexShrink: 0 }}
          />
          <MuiBox
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "6px",
              flex: 1,
            }}
          >
            <Skeleton variant="text" width={140} height={18} />
            <Skeleton variant="text" width={220} height={16} />
          </MuiBox>
        </MuiBox>
      </MuiBox>

      {/* People with access */}
      <MuiBox sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
        <MuiTypography fontWeight="600" variant="14" color="text.darkBlack">
          {t("modal.shareFileFolder.peopleWithAccess")}
        </MuiTypography>

        {Array.from({ length: 3 }).map((_, index) => (
          <MuiBox
            key={index}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <Skeleton
              variant="circular"
              width={40}
              height={40}
              sx={{ flexShrink: 0 }}
            />
            <MuiBox
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "4px",
                flex: 1,
                minWidth: 0,
                pl: "8px",
              }}
            >
              <Skeleton variant="text" width={index === 0 ? 160 : 130} height={16} />
              <Skeleton variant="text" width={index === 0 ? 180 : 150} height={14} />
            </MuiBox>
            <Skeleton
              variant="rounded"
              width={72}
              height={28}
              sx={{ borderRadius: "6px", flexShrink: 0 }}
            />
          </MuiBox>
        ))}
      </MuiBox>
    </MuiBox>
  );
};

export default ShareFolderModalSkeleton;